@if (orientation === 'horizontal') {
  <!-- Horizontal tabs layout -->
  @if (tabs) {
    @for (tab of tabs; track $index) {
      <div
        class="relative flex flex-col items-center justify-between h-16 transition-opacity w-36 disabled:opacity-50"
        [tabindex]="$index"
        [ngClass]="{
          'text-neutral-100 shadow-[inset_0_2px_4px_rgba(0,0,0,0.2)]': tab.id === activeTabId,
          'text-neutral-100/50': tab.id !== activeTabId,
          'cursor-pointer': !tab.disabled,
          'cursor-not-allowed': tab.disabled
        }"
        [attr.disabled]="tab.disabled"
        (click)="setActiveTab(tab.id, tab.disabled)"
        (keydown)="handleKeyDown($event)"
      >
        <div class="flex items-center justify-center flex-grow">
          <span
            class="font-light text-center transition-transform duration-200 hover:scale-105 text-md"
            [class.pointer-events-none]="tab.disabled"
          >
            {{ tab.title }}
          </span>
        </div>

        @if (tab.id === activeTabId) {
          <hr
            class="absolute bottom-0 w-full border-[#00B0D9] border-1.5 transition-all duration-200 self-center"
            [@lineMotionAnimation]="{
              value: '',
              params: {
                widthStart: '0%',
                widthEnd: '50%',
                direction: '50%'
              }
            }"
          />
        }
      </div>
    }
  }
} @else {
  <!-- Vertical sidebar tabs layout -->
  <div class="flex w-full h-auto min-h-0">
    <div class="w-1/4 flex flex-col bg-[#1F1F1FE6] bg-no-repeat bg-padding-box shadow-[0px_30px_60px_#00000066] backdrop-blur-[10px] flex-shrink-0">
      <div class="w-full px-2 py-3 space-y-2 text-gray-400 flex-shrink-0">
        @if (tabs) {
          @for (tab of tabs; track $index) {
            <div
              class="flex items-center space-x-2 h-9 p-2 rounded cursor-pointer transition-all"
              [tabindex]="$index"
              [ngClass]="{
                'bg-white/10': tab.id === activeTabId,
                'opacity-50': tab.id !== activeTabId,
                'cursor-not-allowed': tab.disabled
              }"
              [attr.disabled]="tab.disabled"
              (click)="setActiveTab(tab.id, tab.disabled)"
              (keydown)="handleKeyDown($event)"
              role="button"
            >
              @if (tab.icon) {
                <div class="flex items-center justify-center w-4 h-4">
                  <nrc-icon
                    class="w-full h-full opacity-50"
                    [name]="tab.icon"
                  />
                </div>
              }
              <span class="text-sm font-extralight">{{ tab.title }}</span>
            </div>
          }
        }
      </div>
      <!-- Spacer to push content to top while allowing sidebar to grow -->
      <div class="flex-1"></div>
    </div>

    <!-- Content area (3/4 width) -->
    <div class="w-3/4 flex flex-col flex-1 min-h-0 overflow-hidden border-l-[0.5px] border-gray-500/50">
      <ng-content></ng-content>
    </div>
  </div>
}
